exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".footer_outbox__1pkcw {\n  position: relative;\n  margin-top: 50px;\n  display: flex;\n  justify-content: center;\n  text-align: center;\n  background: #0C0C0C;\n  height: 30px;\n  color: #EEEEEE;\n  text-transform: uppercase;\n  padding-top: 0.5rem;\n  letter-spacing: 0.2em;\n  font-size: .75em; }\n", ""]);

// Exports
exports.locals = {
	"outbox": "footer_outbox__1pkcw"
};